module.exports = __webpack_public_path__ + "img/explication-score-min.bf564c6c.jpg";